import { render, staticRenderFns } from "./DataIterat.vue?vue&type=template&id=6309a1c2"
import script from "./DataIterat.vue?vue&type=script&lang=js"
export * from "./DataIterat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports